import { createKeyedAsyncReducer } from '../../../redux-util/async-helpers';
import {
  LIST_ADOPTION_ASSETS,
  UPDATE_ADOPTION_ASSETS,
} from '../../bridge-method-remap';
import { getAsyncReducerWithModify } from '../../bridge-async-modifier';
import { getBatchUpdateReducer } from '../helpers';

export default createKeyedAsyncReducer({
  actionKeys: [LIST_ADOPTION_ASSETS],
  param: 'adoption',
  itemReducer: getAsyncReducerWithModify({
    fetchKey: LIST_ADOPTION_ASSETS,
    appendNode: 'content',
    itemParam: 'vbid',
  }),
  globalReducer: getBatchUpdateReducer({
    updateAction: UPDATE_ADOPTION_ASSETS,
    paramNodeName: 'assets',
    itemKeyName: 'vbid',
    outputNodeName: 'content',
    useStart: false,
  }),
});
